module.exports = __webpack_public_path__ + "img/video-outline.6f278831.svg";